export const getList = (state) => state.list
export const getCompany = (state) => state.company
